import PageNotFoundError from './PageNotFoundError'

export default PageNotFoundError
